import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';

export interface TcsDataModel {
  provider: string;
  data: {
    event: string;
    platformId: string;
    userId: string;
    serviceId: string;
  };
}

// TODO : Remove when `activateServiceEffect` is no longer used
// Tracking + Autorisation de service pour les service sans consentements
@Injectable({ providedIn: 'root' })
export class TcsWebservice {
  readonly #http = inject(HttpClient);

  readonly #baseUrl = `https://www.${environment.apiDomain}/_api/ta/v1/tcs`;

  send(payload: TcsDataModel): Observable<unknown> {
    return this.#http.post<unknown>(this.#baseUrl, [payload]);
  }
}
